export function booleanFromStringFormat(str: string): boolean {
  return str ? (str.toLowerCase() === 'true' ? true : str.toLowerCase() === 'false' ? false : null) : null;
}
